import React, { useState } from 'react';
import './MessageFeedback.css';

const FEEDBACK_TAGS = [
  { id: 'wrong_facts', label: 'Wrong facts' },
  { id: 'stats_missing', label: 'Stats missing' },
  { id: 'didnt_answer', label: "Didn't answer" },
  { id: 'bad_reasoning', label: 'Bad reasoning' },
  { id: 'too_verbose', label: 'Too long' },
  { id: 'too_short', label: 'Too short' },
  { id: 'confusing', label: 'Confusing' },
  { id: 'hard_to_read', label: 'Hard to read' }
];

const FEEDBACK_API = 'https://5r55p5zwyf7o2ng46cx55fdtoy0ezoxt.lambda-url.us-east-1.on.aws';

const MessageFeedback = ({ messageId, sessionId, userId, responseContent, userQuery, audit, onFeedbackSubmit }) => {
  const [rating, setRating] = useState(null);
  const [selectedTags, setSelectedTags] = useState([]);
  const [comment, setComment] = useState('');
  const [showTags, setShowTags] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleRating = async (newRating) => {
    if (submitted) return;
    setRating(newRating);
    if (newRating === 'down') {
      setShowTags(true);
    } else {
      await submitFeedback(newRating, [], '');
    }
  };

  const toggleTag = (tagId) => {
    setSelectedTags(prev => prev.includes(tagId) ? prev.filter(t => t !== tagId) : [...prev, tagId]);
  };

  const submitFeedback = async (finalRating, tags, finalComment) => {
    setLoading(true);
    try {
      const response = await fetch(FEEDBACK_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          message_id: messageId,
          session_id: sessionId,
          user_id: userId,
          rating: finalRating,
          tags,
          comment: finalComment,
          response_content: responseContent,
          user_query: userQuery,
          audit: audit || {}
        })
      });
      if (response.ok) {
        const result = await response.json();
        setSubmitted(true);
        setShowTags(false);
        onFeedbackSubmit?.({ rating: finalRating, tags, patternDetected: result.pattern_detected });
      }
    } catch (e) {
      console.error('Feedback error:', e);
    }
    setLoading(false);
  };

  if (submitted) {
    return <div className="feedback-submitted">{rating === 'up' ? '👍 Thanks!' : '👎 Thanks for the feedback'}</div>;
  }

  return (
    <div className="message-feedback">
      <div className="feedback-buttons">
        <button className={`feedback-btn ${rating === 'up' ? 'active' : ''}`} onClick={() => handleRating('up')} disabled={loading} title="Helpful">👍</button>
        <button className={`feedback-btn ${rating === 'down' ? 'active' : ''}`} onClick={() => handleRating('down')} disabled={loading} title="Not helpful">👎</button>
      </div>
      {showTags && (
        <div className="feedback-details">
          <div className="feedback-tags">
            {FEEDBACK_TAGS.map(tag => (
              <button key={tag.id} className={`tag-btn ${selectedTags.includes(tag.id) ? 'selected' : ''}`} onClick={() => toggleTag(tag.id)}>{tag.label}</button>
            ))}
          </div>
          <textarea className="feedback-comment" placeholder="Optional: Tell us more" value={comment} onChange={e => setComment(e.target.value.slice(0, 500))} rows={2} />
          <div className="feedback-actions">
            <button className="cancel-btn" onClick={() => { setShowTags(false); setRating(null); }}>Cancel</button>
            <button className="submit-btn" onClick={() => submitFeedback('down', selectedTags, comment)} disabled={loading}>{loading ? '...' : 'Submit'}</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default MessageFeedback;
